import { UnloadService } from '../managers/UnloadManager';
import { Settings } from '../Settings';
var BufferPool = /** @class */ (function () {
    function BufferPool(_tCtrl, maxStoreSize) {
        if (maxStoreSize === void 0) { maxStoreSize = Settings.MAX_BUFFER_POOL_SIZE; }
        this._tCtrl = _tCtrl;
        this.maxStoreSize = maxStoreSize;
        this._store = [];
        if (Settings.ENABLE_UNLOAD_BUFFER) {
            this._manager = UnloadService.createManager({
                name: _tCtrl.name,
                keepAliveTime: Settings.MAX_BUFFER_ALIVE_TIME
            });
        }
    }
    BufferPool.prototype.create = function (gl, arg1, arg2, arg3) {
        var el = this._store.pop();
        if (!el) {
            el = new this._tCtrl(gl, arg1, arg2, arg3);
        }
        else {
            Settings.ENABLE_UNLOAD_BUFFER && this._manager.removeTask(el);
        }
        Settings.ENABLE_UNLOAD_BUFFER && (el.lastUsedTime = this._manager.correctedTime);
        el.apply && el.apply(gl, arg1, arg2, arg3);
        return el;
    };
    BufferPool.prototype.store = function (el) {
        if (!Settings.ENABLE_BUFFER_POOLING || this._store.length === this.maxStoreSize)
            return false;
        if (Settings.ENABLE_UNLOAD_BUFFER) {
            el.lastUsedTime = this._manager.correctedTime;
            this._manager.addTask(el);
        }
        return !!this._store.push(el);
    };
    BufferPool.prototype.remove = function (el) {
        var index = this._store.indexOf(el);
        if (index > -1) {
            this._store.splice(index, 1);
            return true;
        }
        return false;
    };
    BufferPool.prototype.clear = function () {
        this._manager && this._manager.clear();
    };
    return BufferPool;
}());
export { BufferPool };
